import { useMemo } from "react";

import { useIsLoggedIn } from "Flocknote/stateHooks";

import FnrSlides from "UI/FnrSlides";

import LoginButton from "./LoginButton";
import { UserButton } from "./UserButton";

const userAndLoginButtonConfig = [
  { value: LoginButton, key: "loginButton" },
  { value: UserButton, key: "userButton" },
  { value: () => null, key: "nothing" },
];

const UserAndLogin = () => {
  const isLoggedIn = useIsLoggedIn();

  const activeKey = useMemo(() => {
    return isLoggedIn ? "userButton" : "loginButton";
  }, [isLoggedIn]);

  return (
    <FnrSlides
      clip={false}
      variant="subtle"
      components={userAndLoginButtonConfig}
      activeKey={activeKey}
    />
  );
};

export default UserAndLogin;
